import * as React from 'react';

import { FilterFormType, ResidenceFilterForm, FilterSection } from 'components/forms/ResidenceFilterForm';
import { PremisesFilterForm } from 'components/forms/PremisesFilterForm';

interface Props {
    type: FilterFormType;
    scrollToSection?: FilterSection;
}
export const ResidenceFilterModal: React.FunctionComponent<Props> = ({ type, scrollToSection }) => {
    return (
        <div className="residence-filter__modal">
            <div className='modal-body'>
                {type === FilterFormType.PREMISES
                    ? <PremisesFilterForm scrollToSection={scrollToSection} />
                    : <ResidenceFilterForm type={type} scrollToSection={scrollToSection} />
                }
            </div>
        </div>
    )
};
